<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
		<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
		<path d="M19 19L5 5" stroke="currentColor" stroke-width="1"></path>
	</svg>
</div>
